import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.primary.main,
    fontFamily: 'Dazzed',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '24px'
  }
}))

const DazzedHeading12 = ({ className, style = {}, children, regular = true, semibold, onClick }) => {
  const classes = useStyles()

  return (
    <div
      onClick={onClick}
      className={[classes.heading, className].join(' ')}
      style={{ fontWeight: regular ? 400 : semibold ? 500 : 600, ...style }}
    >
      {children}
    </div>
  )
}

export default DazzedHeading12
